import db from 'database';
import Helpers, { findEarliestAvailableID } from 'shared/helpers';
import moment from 'moment';

export default class Contato {
  _id;
  user;
  nome;
  email;
  telefone;
  assunto;
  mensagem;
  enviado;
  createdAt;
  updatedAt;
  deletedAt;

  /**
   *
   * @param {Object} data
   * @param {Number} data.id
   * @param {Number} data.user
   * @param {String} data.nome
   * @param {String} data.email
   * @param {String} data.telefone
   * @param {String} data.assunto
   * @param {String} data.mensagem
   * @param {any} data.enviado
   * @param {String} [data.createdAt]
   * @param {String} [data.updatedAt]
   * @param {String} [data.deletedAt]
   */
  constructor(data) {
    Helpers.constructModel(data, this);
  }

  async save() {
    const curb = await db.contatos.filter(
      x => String(x.id) === String(this.id),
    );
    await curb.delete();
    this.updatedAt = moment()
      .toDate()
      .toISOString();
    this._id = await findEarliestAvailableID(db, 'contatos');
    return db.contatos.put(this);
  }

  static describe = () =>
    '++_id, user, nome, email, telefone, assunto, mensagem, enviado, createdAt, updatedAt, deletedAt';
}
